import { digObject } from '@domain-group/javascript-utils'

import { Box, Image, Text } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import type { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import EntitySelector from '@components/EntitySelector'

import type { TagModel } from '@models/types'

import placeholderImage from '../../assets/agencyMarketingPlaceholder.jpg'

interface TagSearchProps {
  callbacks: {
    selectTag: UseAgencyMarketingPayload['callbacks']['selectTag'],
  },
}

const TagSearch = (props: TagSearchProps) => {
  const { callbacks: { selectTag } } = props

  const { brand } = useAgencySelector()
  const backgroundImageUrl = digObject(brand, 'marketing_cover_image.preserved_1120x1120')
  const logoUrl = digObject(brand, 'logo.small')

  return (
    <Box height={240} marginBottom="large" position="relative">
      <Image
        boxProps={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
        borderRadius={5}
        placeholderUrl={placeholderImage}
        url={backgroundImageUrl}
      />

      <Box
        alignItems="center"
        backgroundColor="rgba(0, 0, 0, 0.75)"
        borderRadius={5}
        flexDirection="column"
        justifyContent="center"
        padding="xlarge"
        zIndex={1}
      >
        <Image backgroundSize="contain" boxProps={{ marginBottom: 'large' }} height={40} width={220} url={logoUrl} />

        <Text color="white" fontSize="medium" letterSpacing="0.5px">
          What would you like to create?
        </Text>

        <EntitySelector
          boxProps={{ maxWidth: 500 }}
          callbacks={{
            // @ts-expect-error TS2322
            selectItem: (entity: TagModel) => selectTag(entity),
          }}
          entityKey="tags"
          entityTitleKey="formatted_title"
          label=""
          marginTop="large"
          searchRequestOptions={{ usable_tags_only: true }}
        />
      </Box>
    </Box>
  )
}

export default TagSearch
